module.exports = __webpack_public_path__ + "2c2a695e82ba4cc2c49b2e74165805f0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/facebook-icon.svg
 ** module id = 207
 ** module chunks = 0
 **/